import { styled } from "@stitches/react";

export const Interactive = styled("button", {
  all: "unset",
  cursor: "pointer",
});
